import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import alertify from "alertifyjs";
import logUserActivity from "../utils/logUserActivity";
import "./Managebooksupplier.css";


const SUPPLIER_FIELD_LABELS = {
  Booksupplier: "Book supplier name",
  Mob: "Mobile number",
  Whatsapp: "WhatsApp number",
  Email: "Email address",
  Address: "Address",
  GSTNumber: "GST number",
  Alternatenumber: "Alternate number",
  Bankname: "Bank name",
  Accountnumber: "Account number",
  Ifsccode: "IFSC code",
  Pancard: "PAN card",
};

const formatSupplierFieldLabel = (key) =>
  SUPPLIER_FIELD_LABELS[key] ||
  key
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/^./, (letter) => letter.toUpperCase());

function Managebooksupplier() {
  const [data, setData] = useState([]);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValues, setEditedValues] = useState({});
  const [originalValues, setOriginalValues] = useState({});

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getbooksupplier`).then(
      (response) => {
        setData(response.data);
      }
    );
  }, []);

  const handleDelete = async (id) => {
    const confirmed = alertify.confirm("Are you sure you want to delete?");
    if (confirmed) {
      try {
        await Axios.delete(`${INVENTORY_API_BASE_URL}/supplier/${id}`);
        setData(data.filter((item) => item._id !== id));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedValues(data[index]);
    setOriginalValues(data[index]);
  };

  const handleInputChange = (e) => {
    setEditedValues({ ...editedValues, [e.target.name]: e.target.value });
  };
  const handleSave = async () => {
    try {
      await Axios.put(
        `${INVENTORY_API_BASE_URL}/editsupplier/${editedValues._id}`,
        editedValues
      );

      const updatedFields = {};
      Object.keys(editedValues).forEach((key) => {
        if (editedValues[key] !== originalValues[key]) {
          updatedFields[key] = {
            old: originalValues[key],
            new: editedValues[key],
          };
        }
      });

      await logUserActivity("EDIT_SUPPLIER", {
        supplierId: editedValues._id,
        updatedFields,
      });

      setEditingIndex(-1);
      setEditedValues({});
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <main className="manage-book-suppliers-page">
      <div className="manage-book-suppliers__content">
        <header className="manage-book-suppliers__header">
          <div>
            <p className="manage-book-suppliers__eyebrow">Supplier directory</p>
            <h1>Manage book suppliers</h1>
            <p className="manage-book-suppliers__subtitle">
              Review supplier contacts and maintain their account details.
            </p>
          </div>
          <div className="manage-book-suppliers__count-card">
            <span className="manage-book-suppliers__count-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M3.5 9.5 12 4l8.5 5.5v10a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1v-10Z" />
                <path d="M8 20.5v-7h8v7M3.5 9.5h17M8 9.5v-2m8 2v-2" />
              </svg>
            </span>
            <span>
              <small>Supplier records</small>
              <strong>{data.length}</strong>
            </span>
          </div>
        </header>

        <section className="manage-book-suppliers__section" aria-labelledby="manage-book-suppliers-heading">
          <div className="manage-book-suppliers__section-heading">
            <div>
              <h2 id="manage-book-suppliers-heading">Supplier details</h2>
              <p>Edit a record or remove a supplier from the directory.</p>
            </div>
            <span className="manage-book-suppliers__record-count">
              {data.length} {data.length === 1 ? "record" : "records"}
            </span>
          </div>

          {data.length ? (
            <div className="manage-book-suppliers__grid">
              {data.map((row, index) => {
                const isEditing = editingIndex === index;
                const supplierName = row.Booksupplier || "Book supplier";
                const avatarText = String(row.Booksupplier || "S").trim().charAt(0).toUpperCase();

                return (
                  <article
                    className={
                      "manage-book-suppliers__card" +
                      (isEditing ? " is-editing" : "")
                    }
                    key={row._id}
                  >
                    <div className="manage-book-suppliers__card-header">
                      <span className="manage-book-suppliers__avatar" aria-hidden="true">
                        {avatarText}
                      </span>
                      <div className="manage-book-suppliers__card-title">
                        <span className="manage-book-suppliers__record-label">
                          Supplier record {String(index + 1).padStart(2, "0")}
                        </span>
                        <h3>{supplierName}</h3>
                      </div>
                      <span className="manage-book-suppliers__status">
                        {isEditing ? "Editing" : "Supplier"}
                      </span>
                    </div>

                    <div className="manage-book-suppliers__fields">
                      {Object.keys(row).map((key) => {
                        if (key === "_id" || key === "__v") return null;

                        const fieldLabel = formatSupplierFieldLabel(key);
                        const value = row[key];
                        const displayValue =
                          value === null || value === undefined || value === ""
                            ? "—"
                            : typeof value === "object"
                              ? JSON.stringify(value)
                              : value;

                        return (
                          <div className="manage-book-suppliers__field" key={key}>
                            <label htmlFor={"supplier-" + index + "-" + key}>
                              {fieldLabel}
                            </label>
                            {isEditing ? (
                              <input
                                id={"supplier-" + index + "-" + key}
                                name={key}
                                value={editedValues[key] || ""}
                                onChange={handleInputChange}
                                aria-label={"Edit " + fieldLabel}
                              />
                            ) : (
                              <span className="manage-book-suppliers__field-value">
                                {displayValue}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    <div className="manage-book-suppliers__actions">
                      {isEditing ? (
                        <>
                          <button
                            type="button"
                            className="manage-book-suppliers__button manage-book-suppliers__button--save"
                            onClick={handleSave}
                          >
                            Save changes
                          </button>
                          <button
                            type="button"
                            className="manage-book-suppliers__button manage-book-suppliers__button--cancel"
                            onClick={() => setEditingIndex(-1)}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="manage-book-suppliers__button manage-book-suppliers__button--edit"
                          onClick={() => handleEdit(index)}
                        >
                          Edit supplier
                        </button>
                      )}
                      <button
                        type="button"
                        className="manage-book-suppliers__button manage-book-suppliers__button--delete"
                        onClick={() => handleDelete(row._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="manage-book-suppliers__empty-state">
              <span className="manage-book-suppliers__empty-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M4 20V8l8-5 8 5v12h-6v-6h-4v6H4Z" />
                  <path d="M8 10h.01M12 10h.01M16 10h.01" />
                </svg>
              </span>
              <strong>No supplier records found</strong>
              <span>Book suppliers will appear here when their records are available.</span>
            </div>
          )}
        </section>
      </div>
    </main>
  );

}

export default Managebooksupplier;
